import { Link } from 'react-router';
import { Icon } from './Icon.jsx';
import styles from './Button.module.css';

const VARIANTS = {
  primary: styles.primary,
  ghost: styles.ghost,
  onDark: styles.onDark,
};

/**
 * Renders as whatever the props imply: a router Link when given `to`, an
 * anchor when given `href`, a real <button> otherwise. Callers never have
 * to choose the element, so a control can't accidentally ship as a div.
 */
export function Button({
  to,
  href,
  variant = 'primary',
  icon = 'arrowRight',
  children,
  className = '',
  ...rest
}) {
  const classes = [styles.btn, VARIANTS[variant] ?? VARIANTS.primary, className]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {children}
      {icon ? <Icon name={icon} /> : null}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {content}
      </Link>
    );
  }

  if (href) {
    const external = /^https?:/.test(href);
    return (
      <a
        href={href}
        className={classes}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : null)}
        {...rest}
      >
        {content}
        {external ? <span className="visually-hidden">(opens in a new tab)</span> : null}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {content}
    </button>
  );
}
